import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { APP_FONT_FAMILY } from "../constants/typography";

const useQuery = () => new URLSearchParams(useLocation().search);

const SuccessPage = () => {
  const { t } = useTranslation();
  const hasActivatedMembership = useRef(false);
  const query = useQuery();

  const email = query.get("email");
  const smoothcompId = query.get("smoothcompId");
  const membershipTypeName = query.get("membershipTypeName");
  const showDigitalCard = query.get("showDigitalCard");
  const sessionId = query.get("session_id");

  useEffect(() => {
    const handleActivateMembership = async (
      emailArg,
      smoothcompIdArg,
      membershipTypeNameArg,
      sessionIdArg
    ) => {
      if (!hasActivatedMembership.current && emailArg) {
        hasActivatedMembership.current = true;
        try {
          await axios.post(
            `${process.env.REACT_APP_CONNECTION_API}/api/activateMembership`,
            {
              email: emailArg,
              smoothcompId: smoothcompIdArg,
              membershipTypeName: membershipTypeNameArg,
              showDigitalCard,
              sessionId: sessionIdArg,
            },
            { withCredentials: true }
          );
        } catch (error) {
          console.error("Failed to activate membership:", error);
        }
      }
    };

    handleActivateMembership(email, smoothcompId, membershipTypeName, sessionId);
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 5000);
    return () => clearTimeout(timer);
  }, [email, smoothcompId, membershipTypeName, showDigitalCard, sessionId]);

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", px: 2, pt: 4, textAlign: "center", fontFamily: APP_FONT_FAMILY }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("breadcrumb_membership_success")}
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 1 }}>
        {t("membership_success_body")}
      </Typography>
      <Typography sx={{ color: "text.secondary" }}>
        {t("membership_success_redirect")}
      </Typography>
    </Box>
  );
};

export default SuccessPage;
